// deps
import { createContext } from "react";

export interface ITableContext {
    tableId?: string;
    restaurantId?: string;
    parentOrderId?: string;
    verifyPinFlow?: boolean;
    setVerifyPinFlow?: (value: boolean) => void;
    updateParentOrderId?: (parentOrderId: string) => void;
}

export default createContext<ITableContext>({
    tableId: undefined,
    restaurantId: undefined,
    parentOrderId: "",
    verifyPinFlow: false,
    setVerifyPinFlow: () => {},
    updateParentOrderId: () => {},
});
